module.exports = new __parcel__URL__("3.142232ea.png").toString();